const NotFound404 = (): JSX.Element => (
  <div>
    <h1> Página no encontrada.</h1>
  </div>
);

export default NotFound404;
